import React, { useState } from "react";
import { motion } from "framer-motion";
import RoadSVG from './education/roadSVG'; 
import educationData from './education/data';
import Checkpoint from './education/CheckPoint'; 
import { containerVariants } from './education/effects'; 
import useIsMobile from '../hooks/isMobile'; 

const Education = () => {
  const [openCardIndex, setOpenCardIndex] = useState(null);
  const isMobileView = useIsMobile(); 

  const handleCheckpointClick = (index) => {
    setOpenCardIndex(openCardIndex === index ? null : index);
  };

  return (
    <div id="education" className="min-h-screen py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold mb-4
            bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600
            bg-clip-text text-transparent pb-2">
            Education
          </h2>
          <p className="text-neutral-600 dark:text-neutral-400 text-lg max-w-2xl mx-auto">
            A brief overview of my academic background—{isMobileView ? 'tap' : 'hover'} to see the destination details.
          </p>
        </div>

        {/* Main Timeline Container */}
        <motion.div 
          className="relative w-full h-64 md:h-80 mt-20"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.2 }}
        >
          <RoadSVG />

          {/* Map over data and render the Checkpoint component */}
          {educationData.map((item, index) => (
            <Checkpoint
              key={index}
              item={item}
              index={index}
              totalItems={educationData.length}
              isOpen={openCardIndex === index}
              onClick={() => handleCheckpointClick(index)}
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Education;